import { type IWidgetParsedProps } from '@framework/engine/schema/widgets/repository/inputs/common/util/getWidgetProps.ts';
import { type IUploadWidget } from '../IUploadWidget.ts';

export function useUploadWidgetHelpText(params: {
  widget: IUploadWidget;
  options: IWidgetParsedProps;
  publicUpload: boolean | null | undefined;
}) {
  const { widget, options, publicUpload } = params;
  const helpText = publicUpload ? widget.publicHelpText : options?.helpText;

  return helpText ?? null;
}
